import {observable, action, runInAction, computed} from 'mobx'
import {message} from 'antd'
import {json, get} from '../../../../utils/ajax'
import moment from 'moment';

class NoticeBreakPointStore {
    @observable loading
    @observable list
    @observable page
    @observable noticeId//通知书id
    @observable factorySearch //工厂下拉框供选择值
    @observable mainTainBreakPointModal//新增断点弹出层是否显示字段
    @observable editFields //表单选中值
    @observable updatePointModal//维护弹出层是否显示字段
    @observable pointId//断点sid
    @observable typeSearch//版本下拉框供选择值
    @observable noticeCid
    @observable Maintain
    @observable modelStatus
    @observable addPointModal  //新增断点模态框

    constructor() {
        this.loading = false
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger: true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.noticeId = ""
        this.factorySearch = []
        this.mainTainBreakPointModal = false
        this.editFields = {
            factoryCode: "",
            receptionVin: "",
            type: "",
            breakTime: null,
            materialCodesList: ['']
        }
        this.updatePointModal = false
        this.pointId = ""
        this.typeSearch = ["国内", "国外"]
        this.noticeCid=''
        this.Maintain=''
        this.modelStatus=false
        this.addPointModal = false
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**
     * 初始化工厂下拉框可选值
     */
    @action
    initFactorySearch = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '基地/'})
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.factorySearch = res.children
            this.loading = false
        })
    }

    /**
     * 进入页面查询对应断点
     * @returns {Promise<void>}
     */
    @action
    initNoticBreakPoint = async (noticeId, page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/queryAllBreakPointByNotice/${noticeId}`, {
            page: page
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.noticeId = noticeId
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
            }
            this.loading = false
        })
    }

    /**
     *翻页
     */
    @action
    pageQueryNoticeBreakPoint = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/queryAllBreakPointByNotice/${this.noticeId}`, {
            page: page
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger: true,
                pageSize:20,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 删除断点
     * @returns {Promise<void>}
     */
    @action
    delBreakPoint = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/killBreakPoint/${id}`)
        if (res && res.status === 0) {
            runInAction(()=>{
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
        })
        await this.initNoticBreakPoint(this.noticeId, this.page.current) //刷新页面
    }

    /**
     * 显示弹出层
     */
    @action
    showMainBreakPointModal = (flag) => {
        runInAction(() => {
            this.loading = true
            flag && this.emptyForm()
            this.mainTainBreakPointModal = true
            this.loading = false
        })
    }

    /**
     * 隐藏添加弹出层
     */
    @action
    hiddenMainBreakPointModal = () => {
        runInAction(() => {
            this.loading = true
            this.mainTainBreakPointModal = false
            this.loading = false
            this.addPointModal = false
        })
        this.emptyForm()
    }

    /**
     * 重置Form
     */
    @action
    emptyForm = () => {
        runInAction(() => {
            this.editFields = {
                factoryCode: "",
                receptionVin: "",
                type: "",
                breakTime: null,
                materialCodesList: ['']
            }
        })
    }

    /**
     * 添加
     */
    @action
    saveForm = async () => {
        runInAction(() => {
            this.loading = true
        })
        for (let i = 0; i < this.editFields.materialCodesList.length; i++) {    //判断页面输入的物料号集合是否有重复
            for (let j = i + 1; j < this.editFields.materialCodesList.length; j++) {
                if (this.editFields.materialCodesList[i].materialCode.trim() === this.editFields.materialCodesList[j].materialCode.trim()) {
                    message.warning(this.editFields.materialCodesList[i].materialCode.trim() + " 物料号重复，请勿重复添加物料号")
                    return
                }
            }
        }
        let editFieldsValue = this.editFields
        const result = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/queryMaterialIsExitByFactoryForAdd/${this.editFields.factoryCode}`)
        for (let i = 0; i < this.editFields.materialCodesList.length; i++) { //判断物料号是否存在数据库
            for (let j = 0; j < result.length; j++) {
                if (this.editFields.materialCodesList[i].materialCode === result[j]) {
                    message.warning(this.editFields.materialCodesList[i].materialCode.trim() + " 物料号已存在，请勿重复添加")
                    runInAction(() => {
                        this.loading = false
                    })
                    return
                }
            }
        }
        let data = {
            factoryCode: editFieldsValue.factoryCode,
            receptionVin: editFieldsValue.receptionVin.trim(),
            type: editFieldsValue.type !== "国外" ? 0 : 1, //eslint-disable-line
            breakTime: moment(editFieldsValue.breakTime).format("YYYY-MM-DD"),
            materialCodesList: editFieldsValue.materialCodesList,
            noticeId: this.noticeId
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/saveNoticeBreakPoint`, data)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.mainTainBreakPointModal = false
            this.loading = false
        })
        await this.pageQueryNoticeBreakPoint(this.page.current) //刷新页面
    }

    /**
     * 查询对应通知书内容，赋值到form
     * 显示维护弹出层
     */
    @action
    showUpdatePointModal = async (id) => {
        this.Maintain=id
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/selectPoint`, {id: id})
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.editFields = {
                factoryCode: res.factoryCode,
                receptionVin: res.receptionVin,
                type: res.type !== 1 ? "国内" : "国外",//eslint-disable-line
                breakTime: moment(res.breakTime),
                materialCodesList: res.materialCodesList,
            }
            this.pointId = id
            this.loading = false
            this.updatePointModal = true
        })
    }

    /**
     * 隐藏维护弹出层
     */
    @action
    hiddenUpdateBreakPointModal = () => {
        runInAction(() => {
            this.loading = true
            this.updatePointModal = false
            this.loading = false
        })
    }

    /**
     * form绑值
     * @param changedFields
     */
    @action
    onEditConfigFieldChange(changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            factoryCode: fields.factoryCode.value,
            receptionVin: fields.receptionVin.value,
            type: fields.type.value,
            breakTime: fields.breakTime.value,
            materialCodesList: []
        }
        this.editFields.materialCodesList.forEach((item, index) => {
            editFields.materialCodesList[index] = {
                materialCode: fields[`materialCode-${index}`].value
            }
        })

        this.editFields = editFields
    }

    /**
     * 回显
     * @returns {{factoryCode: {value: string}, receptionVin: {value: string}, type: {value: string}, breakTime: {value: string}}}
     */
    @computed
    get fields() {
        let fields = {
            factoryCode: {value: this.editFields.factoryCode},
            receptionVin: {value: this.editFields.receptionVin},
            type: {value: this.editFields.type},
            breakTime: {value: this.editFields.breakTime},
        }
        if (this.editFields.materialCodesList) {
            this.editFields.materialCodesList.forEach((item, index) => {
                fields[`materialCode-${index}`] = {value: item.materialCode}
            })
        }
        return fields
    }

    /**
     * 修改
     */
    @action
    updateBreakPoint = async () => {
        runInAction(() => {
            this.loading = true
        })
        for (let i = 0; i < this.editFields.materialCodesList.length; i++) {    //判断页面输入的物料号集合是否重复
            for (let j = i + 1; j < this.editFields.materialCodesList.length; j++) {
                if (this.editFields.materialCodesList[i].materialCode.trim() === this.editFields.materialCodesList[j].materialCode.trim()) {
                    message.warning(this.editFields.materialCodesList[i].materialCode.trim() + " 物料号重复，请勿重复添加物料号")
                    runInAction(() => {
                        this.loading = false
                    })
                    return
                }
            }
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/queryMaterialIsExitByFactory/${this.editFields.factoryCode}/${this.pointId}`)
        for (let i = 0; i < this.editFields.materialCodesList.length; i++) {   //判断物料号是否存在数据库
            for (let j = 0; j < res.length; j++) {
                if (this.editFields.materialCodesList[i].materialCode.trim() === res[j]) {
                    message.warning(this.editFields.materialCodesList[i].materialCode.trim() + " 物料号已存在，请勿重复添加")
                    runInAction(() => {
                        this.loading = false
                    })
                    return
                }
            }
        }
        const data = {
            factoryCode: this.editFields.factoryCode,
            receptionVin: this.editFields.receptionVin.trim(),
            type: this.editFields.type !== "国外" ? 0 : 1,//eslint-disable-line
            breakTime: moment(this.editFields.breakTime).format("YYYY-MM-DD"),
            materialCodesList: this.editFields.materialCodesList,
            id: this.pointId,
            noticeId: this.noticeId,
        }
        const result = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/noticeBreakPoint/modifyNoticeBreakPoint`, data)
        if (result && result.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.updatePointModal = false
            this.modelStatus=true
            this.loading = false
        })
        await this.pageQueryNoticeBreakPoint(this.page.current)   //刷新頁面
    }

    /**
     * 添加输入物料栏
     */
    @action
    addMaterialCode = () => {
        runInAction(() => {
            this.loading = true
            this.editFields.materialCodesList.push('')
            this.loading = false
        })
    }

    /**
     * 删除物料号输入栏
     * @param index
     */
    @action
    delMaterialCode = async (index) => {
        runInAction(() => {
            this.loading = true
            this.editFields.materialCodesList = this.editFields.materialCodesList.filter((item, i) => i !== index)
            this.loading = false
        })
    }

    @action
    clickSubmitBtnHaveErrorCallBack = () => {
        runInAction(() => {
            this.loading = true
            this.editFields.materialCodesList = ['']
            this.loading = false
        })
    }
}

export default new NoticeBreakPointStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/LetterNotice/NoticeBreakPoint/store.js